import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const FeatureFlagsPage = lazy(() =>
  import('../../pages/admin/feature-flags/FeatureFlagsPage').then((m) => ({
    default: m.FeatureFlagsPage,
  })),
);

export const Route = createFileRoute('/admin/feature-flags')({
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <FeatureFlagsPage />
    </Suspense>
  ),
});
